import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "display",
  "use": "display-usage",
  "viewBox": "0 0 27.43 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.43 24\" id=\"display\"><defs><style>#display .cls-1{opacity:.8}</style></defs><title>资源 16</title><g id=\"display_图层_2\" data-name=\"图层 2\"><g id=\"display_图层_1-2\" data-name=\"图层 1\"><path d=\"M25.71 0h-24A1.56 1.56 0 0 0 0 1.71V18a1.56 1.56 0 0 0 1.71 1.71H12v2.57H6.86a.78.78 0 0 0-.86.86V24h15.42v-.86a.78.78 0 0 0-.86-.86h-5.13v-2.57h10.28A1.56 1.56 0 0 0 27.43 18V1.71A1.56 1.56 0 0 0 25.71 0zm-13 17.44a1 1 0 1 1 1 1 1 1 0 0 1-1-1zm-11-2V1.71h24v13.72z\" /><path d=\"M17.44 8.46h-3.77V4.69a.18.18 0 0 0-.18-.18 4.15 4.15 0 1 0 4.17 4.17.18.18 0 0 0-.22-.22z\" /><path class=\"cls-1\" d=\"M18.41 7.85a4.15 4.15 0 0 0-4.13-4.13.18.18 0 0 0-.18.18v4a.18.18 0 0 0 .18.18h4a.18.18 0 0 0 .18-.18z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/display.svg
// module id = 6ZRZ
// module chunks = 6